import type { TradeChartMetric } from '@/events/trading';

/** Read the chart on the traded market's detail page, if one is mounted. */
export function readTradeChartMetric(marketAddress: string | undefined): TradeChartMetric {
  if (typeof document === 'undefined' || marketAddress === undefined) return 'none';
  const chart = Array.from(
    document.querySelectorAll<HTMLElement>('[data-trade-chart-market]'),
  ).find((element) => element.dataset.tradeChartMarket === marketAddress);
  if (chart === undefined) return 'none';
  const metric = chart.dataset.tradeChartMetric;
  return isTradeChartMetric(metric) ? metric : 'unknown';
}

export function isTradeChartMetric(value: string | undefined): value is TradeChartMetric {
  return (
    value === 'market_share' ||
    value === 'market_cap' ||
    value === 'price' ||
    value === 'none' ||
    value === 'unknown'
  );
}
